import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, init } from '@tripian/core';
import Model from '@tripian/model';
import { GoogleMapsPoiInfo, PageLoading, PoiInfoImage, PoiInfoText } from '@tripian/react';
import { PLACE_INFO } from '../../constants/ROUTER_PATH_TITLE';
import config from '../../config';

const PlaceInfo = () => {
  const [poiInfo, setPoiInfo] = useState<Model.Poi>();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  document.title = PLACE_INFO.TITLE;

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    let unmonted = false;

    init(config.TRIPIAN_API_URL, config.TRIPIAN_API_KEY);
    api
      .poi(Number(id))
      .then((poiInfoResponse) => {
        if (!unmonted) setPoiInfo(poiInfoResponse);
      })
      .catch((err) => {
        setErrorMessage(err);
      })
      .then(() => {
        setLoading(false);
      });

    return () => {
      unmonted = true;
    };
  }, [id]);

  if (loading) {
    return <PageLoading />;
  }

  const openTableProduct = poiInfo?.booking.find((b) => b.provider_id === 5)?.product;

  return (
    <>
      {poiInfo && !errorMessage ? (
        <div className="row mb0" style={{ height: 'calc(100% - 90px)', width: '100%', alignItems: 'center' }}>
          <div className="col col12 col6-m">
            <PoiInfoImage poi={poiInfo} favorite={false} hideButtons favoriteClick={() => {}} close={() => {}} favoriteLoading={false} square />
          </div>
          <div className="col col12 col6-m">
            <div className="row">
              <div className="col col12">
                <PoiInfoText
                  poi={poiInfo}
                  hideBookingButton={!openTableProduct}
                  bookingButtonClick={() => {
                    if (openTableProduct) window.open(openTableProduct.url || 'https://www.opentable.com');
                    // eslint-disable-next-line no-console
                    else console.log('Open Table değil.');
                  }}
                />
              </div>
              <div className="col col12" style={{ height: '320px', width: '100%' }}>
                <GoogleMapsPoiInfo poi={poiInfo} zoom={17} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="full-center" style={{ maxWidth: '100%', textAlign: 'center' }}>
          <span>{errorMessage}</span>
        </div>
      )}
    </>
  );
};

export default PlaceInfo;
